<template>
  <v-navigation-drawer
      :mini-variant-width="70"
      app
      :permanent="!isMobile"
      :expand-on-hover="!isMobile"
      v-model="isMenuOpen"
      :style="{ background: 'var(--main-color)', height: '100%' }"
  >
    <v-list>
      <div 
        v-for="(menu, i) in menus" 
        :key="`menu-professor-${i}`">
        <list-item
            v-if="!menu.group"
            :item="menu"
            @modalAppAgenda="$emit('modalAppAgenda')"
            @modalSair="$emit('modalSair')"
            @action="clickAcaoMenu"
        />
        <list-group-item
            v-else
            @modalAppAgenda="$emit('modalAppAgenda')"
            :menu="menu"
        />
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import ListItem from "./ListItem";
import ListGroupItem from "./ListGroupItem";
import api from "@/api";

export default {
  name: "NavbarSecretaria",
  props: ["toggleMenu", "modalAppAgenda"],
  components: { ListItem, ListGroupItem },

  data() {
    return {
      isMenuOpen: false,
      menus: [],
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600;
    },
  },

  watch: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },

  created() {
    this.fetchMenus();
  },

  methods: {
    async fetchMenus() {
      try {
        const response = await api.get("/modulos/lista");
        if (!response.data) {
          throw new Error("Resposta da API está vazia!");
        }
        this.menus = response.data;
      } catch (error) {
        console.error(
            "Erro ao buscar o menu:",
            error.response ? error.response.data : error.message
        );
      }
    },

    clickAcaoMenu(menu) {
      if (menu.action) {
        menu.action();
      }
    },
  },
};
</script>
